import Client from "./client"

export default class OCR {
    constructor() {
        this.client = new Client()
    }

    async listModels() {
        return this.client.http().get('/v3/dms/media/ocr/models')
    }

    async createModel(data) {
        return this.client.http().post('/v3/dms/media/ocr/model', data)
    }

    async getModel(uuid) {
        return this.client.http().get(`/v3/dms/media/ocr/model/${uuid}`)
    }

    async updateModel(uuid, data) {
        return this.client.http().put(`/v3/dms/media/ocr/model/${uuid}`, data)
    }

    async deleteModel(uuid) {
        return this.client.http().delete(`/v3/dms/media/ocr/model/${uuid}`)
    }

    async addSample(modelUuid, data) {
        return this.client.http().post(`/v3/dms/media/ocr/model/${modelUuid}/sample`, data)
    }

    async updateSample(modelUuid, sampleUuid, data) {
        return this.client.http().put(`/v3/dms/media/ocr/model/${modelUuid}/sample/${sampleUuid}`, data)
    }

    async removeSample(modelUuid, sampleUuid) {
        return this.client.http().delete(`/v3/dms/media/ocr/model/${modelUuid}/sample/${sampleUuid}`)
    }

    async extract(data) {
        return this.client.http().post('/v3/dms/media/ocr/extract', data, {
            timeout: 120000
        })
    }

    async getPlan() {
        return this.client.http().get('/v3/dms/media/plan')
    }
}
